import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import Theme from '../../../../Themes/ThemeArtLexie'
import Settings from '../../Settings/Settings';
import AppbarSubcomponent from './Subcomponents/Appbar'
import Style from './Styles/AppbarStyle'
import ErrorSnackbar from '../../../../CommonComponents/ErrorSnackbar/ErrorSnackbar';
export default class Appbar extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.basicComponentConstants = {
            language: props.componentMethods.getManagerState().language,
        }
    }

    componentDidMount() {

        if(!this.getLocalStorage('shoppingCart')) {
            this.postShoppingCartAction()
        } else {
            this.getShoppingCartTotal()
        }

         if (this.getLocalStorage('shoppingCart') && this.getLocalStorage('shoppingCart').shoppingCartUsersID && !this.getLocalStorage('user')) {

            this.postShoppingCartAction()
        }
        super.componentDidMount()
    }

    getShoppingCartTotal() {
        const that = this
        let accountToken = ''
        if(this.getLocalStorage('user')) {
            accountToken = '?accountToken=' + this.getLocalStorage('user').tokensHash;
        }
        this.ajax(Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART_TOTAL + this.getLocalStorage('shoppingCart').shoppingCartSha + accountToken, {},'GET',null, (data) => {
            that.props.componentMethods.setManagerState({shoppingCartTotal: data.items.total})
        })
    }

    postShoppingCartAction() {
        const that = this
        let accessToken = ''
        if(this.getLocalStorage('user')) {
            accessToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        if(!this.props.componentMethods.getManagerState().loadingPostShoppingCart) {
            this.props.componentMethods.setManagerState({loadingPostShoppingCart: true}, () => {
                this.ajax(Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART + accessToken,{},'POST',null, (data) => {
                    that.saveLocalStorage(data.items[0], 'shoppingCart')
                    that.props.componentMethods.setManagerState({loadingPostShoppingCart: false})
                    that.getShoppingCartTotal()
                    if (that.props.componentMethods.refreshCheckout)
                        that.props.componentMethods.refreshCheckout()
                })
            })    
        }
    }
    
    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('Appbar', {
            ...this.basicComponentConstants
        }).setComponentsMethods('Appbar', {
            setManagerState: (object, callback) => {
                that.props.componentMethods.setManagerState(object, callback)
            },
            refreshMainComponent: () => {
                that.refresh()
            },
            getManagerState: () => {
                return that.props.componentMethods.getManagerState()
            },
            changeRoute: (route) => {
                that.props.componentMethods.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.getLocalStorage(storageName)
            },
            getSubscribersFeedAction: () => {
                that.getSubscribersFeedAction()
            },
            getShoppingCartItemsAction: () => {
                let url = Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCARTITEMS + that.props.componentMethods.getLocalStorage('shoppingCart').shoppingCartSha
                let accountToken = ''
                if(that.props.componentMethods.getLocalStorage('user') && that.props.componentMethods.getLocalStorage('user').tokensHash) {
                    accountToken = '?accountToken=' + that.props.componentMethods.getLocalStorage('user').tokensHash
                }
                that.props.componentMethods.setManagerState({loadingShoppingCartItems: true, shoppingCartItems: []}, () => {
                    that.ajax(url += accountToken, 
                        {}, 
                       "GET", 'shoppingCartItems', 
                        (data) => {
                           that.props.componentMethods.setManagerState({shoppingCartItems: data.items, loadingShoppingCartItems: false})
                       })
                })
            },
            hasAccess: (accessLevel) => {
                return that.hasAccess(accessLevel)
            },
            ajax: (url, 
                dataObject = {}, 
                method, stateValue = '', 
                callback = () => {}, 
                headers = {}, 
                setState = true, 
                catchCallback = () => {}) => {
                    that.ajax (url, 
                        dataObject, 
                        method, stateValue, 
                        callback, 
                        headers, 
                        setState, 
                        catchCallback);
                },
        })
    }

    getRender() {
        const classes = Style()
        this.loadComponentsProps()
        return <div style={classes.root} id="rootComponent">
                    <AppbarSubcomponent {...this.buildComponentProps("Appbar")} />
                    {this.props.componentMethods.getManagerState().errors.map((element, index) => { 
                        return <ErrorSnackbar message={element} index={index} key={index} clearErrorMessage={this.props.componentMethods.clearErrorMessage}/>
                     })}
                </div>
    }
}
